import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Orders = () => <PlaceholderPage title="주문 관리" description="세탁 주문 접수와 진행 상태를 관리해요." />;

export default Orders;
